<template>
  <div class="status-bar">
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<style scoped>
.status-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 10px;
  padding: 4px 24px 0;
  color: #000;
}

.time {
  font-size: 15px;
  font-weight: 600;
}

.icons {
  display: flex;
  align-items: center;
  gap: 6px;
}
</style>
